import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

// :: Modules
// :: Damage Modules
import user from "@/store/user";
import checklist from "@/store/damage/checklist";
import checklistImages from "@/store/damage/checklist/images";
import detail from "@/store/damage/detail";
import dashboard from "@/store/damage/dashboard";
import orders from "@/store/damage/orders";
import transfers from "@/store/transfers";

// :: Dynamic-Board Modules
import machines from "@/store/dynamic-board/machines";
import services from "@/store/dynamic-board/services";
import people from "@/store/dynamic-board/people-ranking";

// :: PWA module
import pwa from "@/store/pwa";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  // :: Modules that need persistence
  modules: ["checklistImages", "user"]
});

const store = new Vuex.Store({
  modules: {
    user,
    transfers,
    checklist,
    checklistImages,
    detail,
    dashboard,
    orders,
    machines,
    services,
    people,
    pwa
  },
  plugins: [vuexLocal.plugin]
});

export default store;
